import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FullScreenModal from 'components/consumer/FullScreenModal';
import IconMobileGrid1x from 'components/icons/iconMobileGrid1x';
import IconMobileGrid2x from 'components/icons/iconMobileGrid2x';
import ToggleTabGroup from 'components/consumer/ToggleTabGroup';
import Placeholder from 'components/consumer/Placeholder';
import getTabContentId from 'commons/getTabContentId';
import getTabId from 'commons/getTabId';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
import useJumpToSelectedGalleryPhoto from './hooks/useJumpToSelectedGalleryPhoto';
const PDPFullScreenGalleryBodyPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Placeholder loading={true} type="rect" style={{
      width: "100%",
      height: "50vh",
      margin: 0
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const PDPFullScreenGalleryBody = loadable(() => import('./PDPFullScreenGalleryBody'), {
  fallback: <PDPFullScreenGalleryBodyPlaceholder />,
  loading: PDPFullScreenGalleryBodyPlaceholder
});
const PDPFullScreenGallery = t0 => {
  const $ = _c(47);
  const {
    className: t1,
    displayShownIn: t2,
    enableCrops: t3,
    pdpIsModularBYOProduct: t4,
    initialSelectedPhotoIndex: t5,
    isEditOrder: t6,
    isOpen: t7,
    onClose,
    onDismiss,
    onPhotoViewed,
    photos: t8,
    productName: t9,
    showGridView: t10
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const displayShownIn = t2 === undefined ? false : t2;
  const enableCrops = t3 === undefined ? true : t3;
  const pdpIsModularBYOProduct = t4 === undefined ? false : t4;
  const initialSelectedPhotoIndex = t5 === undefined ? 0 : t5;
  const isEditOrder = t6 === undefined ? false : t6;
  const isOpen = t7 === undefined ? false : t7;
  let t11;
  if ($[0] !== t8) {
    t11 = t8 === undefined ? [] : t8;
    $[0] = t8;
    $[1] = t11;
  } else {
    t11 = $[1];
  }
  const photos = t11;
  const productName = t9 === undefined ? "" : t9;
  const showGridView = t10 === undefined ? false : t10;
  const {
    isMobileOrTablet
  } = useScreen();
  const [mobileColumnsAcross, setMobileColumnsAcross] = useState(1);
  const is2MobileColumns = mobileColumnsAcross === 2;
  const [isPinchGalleryOpen, setIsPinchGalleryOpen] = useState(false);
  const [pinchGalleryIndex, setPinchGalleryIndex] = useState(0);
  const [hasOpened, setHasOpened] = useState(isOpen);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(initialSelectedPhotoIndex);
  let t12;
  let t13;
  if ($[2] !== initialSelectedPhotoIndex) {
    t12 = () => {
      setSelectedPhotoIndex(initialSelectedPhotoIndex);
    };
    t13 = [initialSelectedPhotoIndex];
    $[2] = initialSelectedPhotoIndex;
    $[3] = t12;
    $[4] = t13;
  } else {
    t12 = $[3];
    t13 = $[4];
  }
  useEffect(t12, t13);
  let t14;
  let t15;
  if ($[5] !== isOpen) {
    t14 = () => {
      if (isOpen) {
        setHasOpened(true);
      }
    };
    t15 = [isOpen];
    $[5] = isOpen;
    $[6] = t14;
    $[7] = t15;
  } else {
    t14 = $[6];
    t15 = $[7];
  }
  useEffect(t14, t15);
  let t16;
  if ($[8] !== isOpen || $[9] !== selectedPhotoIndex) {
    t16 = {
      selectedPhotoIndex,
      isOpen
    };
    $[8] = isOpen;
    $[9] = selectedPhotoIndex;
    $[10] = t16;
  } else {
    t16 = $[10];
  }
  const galleryRef = useJumpToSelectedGalleryPhoto(t16);
  const [selectedDesktopTab, setSelectedDesktopTab] = useState("Listed");
  const selectedTab = isMobileOrTablet ? "Listed" : selectedDesktopTab;
  const shouldLoadBody = isOpen || hasOpened;
  let t17;
  if ($[11] !== onClose || $[12] !== onDismiss) {
    t17 = () => {
      onDismiss?.();
      onClose();
    };
    $[11] = onClose;
    $[12] = onDismiss;
    $[13] = t17;
  } else {
    t17 = $[13];
  }
  let t18;
  if ($[14] !== selectedTab || $[15] !== showGridView) {
    t18 = showGridView ? <ToggleTabGroup selectedTab={getTabId(selectedTab, "PDPFullScreenGallery")} noBottomBorder={true} size="md" aria-label="Full Screen Gallery Grid" items={["Listed", "Grid"].map(label => ({
      id: getTabId(label, "PDPFullScreenGallery"),
      label,
      contentId: getTabContentId(label, "PDPFullScreenGallery"),
      onClick: () => {
        setSelectedDesktopTab(label);
      }
    }))} /> : undefined;
    $[14] = selectedTab;
    $[15] = showGridView;
    $[16] = t18;
  } else {
    t18 = $[16];
  }
  let t19;
  if ($[17] !== productName) {
    t19 = <span className="text-sm font-bold items-center text-gray flex h-full justify-center">{productName}</span>;
    $[17] = productName;
    $[18] = t19;
  } else {
    t19 = $[18];
  }
  let t20;
  if ($[19] !== is2MobileColumns) {
    t20 = <div className="items-center flex h-full" role="button" tabIndex="0" onClick={() => {
      setMobileColumnsAcross(is2MobileColumns ? 1 : 2);
    }}>{is2MobileColumns ? <IconMobileGrid2x /> : <IconMobileGrid1x />}</div>;
    $[19] = is2MobileColumns;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] !== className || $[22] !== displayShownIn || $[23] !== enableCrops || $[24] !== galleryRef || $[25] !== is2MobileColumns || $[26] !== isEditOrder || $[27] !== isMobileOrTablet || $[28] !== isPinchGalleryOpen || $[29] !== mobileColumnsAcross || $[30] !== onClose || $[31] !== onPhotoViewed || $[32] !== pdpIsModularBYOProduct || $[33] !== photos || $[34] !== pinchGalleryIndex || $[35] !== productName || $[36] !== selectedTab || $[37] !== shouldLoadBody) {
    t21 = shouldLoadBody && <PDPFullScreenGalleryBody className={className} displayShownIn={displayShownIn} enableCrops={enableCrops} galleryRef={galleryRef} is2MobileColumns={is2MobileColumns} isEditOrder={isEditOrder} isMobileOrTablet={isMobileOrTablet} isPinchGalleryOpen={isPinchGalleryOpen} mobileColumnsAcross={mobileColumnsAcross} onClose={onClose} onPhotoViewed={onPhotoViewed} pdpIsModularBYOProduct={pdpIsModularBYOProduct} photos={photos} pinchGalleryIndex={pinchGalleryIndex} productName={productName} selectedTab={selectedTab} setIsPinchGalleryOpen={setIsPinchGalleryOpen} setPinchGalleryIndex={setPinchGalleryIndex} setSelectedDesktopTab={setSelectedDesktopTab} setSelectedPhotoIndex={setSelectedPhotoIndex} />;
    $[21] = className;
    $[22] = displayShownIn;
    $[23] = enableCrops;
    $[24] = galleryRef;
    $[25] = is2MobileColumns;
    $[26] = isEditOrder;
    $[27] = isMobileOrTablet;
    $[28] = isPinchGalleryOpen;
    $[29] = mobileColumnsAcross;
    $[30] = onClose;
    $[31] = onPhotoViewed;
    $[32] = pdpIsModularBYOProduct;
    $[33] = photos;
    $[34] = pinchGalleryIndex;
    $[35] = productName;
    $[36] = selectedTab;
    $[37] = shouldLoadBody;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== isOpen || $[40] !== isPinchGalleryOpen || $[41] !== t17 || $[42] !== t18 || $[43] !== t19 || $[44] !== t20 || $[45] !== t21) {
    t22 = <FullScreenModal isOpen={isOpen} onClose={t17} headerLeft={t18} mobileNoPadding={true} mobileHeaderCenter={t19} mobileHeaderRight={t20} mobileHeaderNoPointerEvents={isPinchGalleryOpen}>{t21}</FullScreenModal>;
    $[39] = isOpen;
    $[40] = isPinchGalleryOpen;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
};
PDPFullScreenGallery.propTypes = {
  className: PropTypes.string,
  displayShownIn: PropTypes.bool,
  enableCrops: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  initialSelectedPhotoIndex: PropTypes.number,
  isEditOrder: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onDismiss: PropTypes.func,
  onPhotoViewed: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    src: PropTypes.string
  })),
  productName: PropTypes.string,
  showGridView: PropTypes.bool
};
export default withBrowserOnly(PDPFullScreenGallery);